import * as React from "react";

import { Router } from '@reach/router';
// Marketing home page
import FramableLocationSearch from '../preRegister/FramableLocationSearch';
import LaunchLocationSearch from '../address/FramableLocationSearch';

const FramedModules = () => {
  return ( 
    <Router>
      <FramableLocationSearch path="/signUp/framableLocationSearch" />
      {/* this last one is the only one in use */}
      <LaunchLocationSearch path="/launchLocationSearch" />
    </Router>
  ); 
}

export default FramedModules;